/**
 * Scrolls user to top of page when clicked.
 * @author Abigail Kesler <https://github.com/abingail>
 */

(function ($) {
  'use strict';

  Drupal.behaviors.initializeScrollTop = {
    attach: (context) => {
      if (context === document) {
        initialize();
      }
    },
  };

  function initialize() {
    $("a[href='#top']").click(function () {
      $('html, body').animate({ scrollTop: 0 }, 'slow');
      return false;
    });
  }
})(jQuery);
